/** Shared shop kiosk pilot login — redirect to kiosk when this user is logged in. */
export const KIOSK_PILOT_EMAIL = 'kiosk-pilot@example.com';
